/**
 * Invalid-segment and duplicate-email notes shown after Parse on Create Administrators.
 */

import { Note, NOTE_TYPE } from '../../../../../components/note/note';

export interface ICreateAdministratorsParseFeedbackProps {
    invalidParseEntries: string[];
    duplicateParseEntries: string[];
}

const CreateAdministratorsParseFeedback: React.FC<ICreateAdministratorsParseFeedbackProps> = ({
    invalidParseEntries,
    duplicateParseEntries,
}) => {
    if (invalidParseEntries.length === 0 && duplicateParseEntries.length === 0) {
        return null;
    }

    return (
        <div className="create-administrators-page__parse-feedback">
            {invalidParseEntries.length > 0 && (
                <Note
                    type={NOTE_TYPE.ERROR}
                    caption="Invalid or unparsed entries"
                    body={`These values are not valid emails or could not be turned into a user row. Correct them in the list above and parse again: ${invalidParseEntries.map((entry) => `"${entry}"`).join(', ')}`}
                />
            )}
            {duplicateParseEntries.length > 0 && (
                <Note
                    type={NOTE_TYPE.INFORMATION}
                    caption="Skipped duplicates"
                    body={`These emails appeared more than once in your input. Each address was only added once: ${duplicateParseEntries.join(', ')}`}
                />
            )}
        </div>
    );
};

export default CreateAdministratorsParseFeedback;
